import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Heart } from "lucide-react";

const EmsOrganTransport = () => {
  const serviceData = {
    serviceName: "Emergency Medical Services",
    heroImage: require("../../assets/ems_main.png"),
    heroTagline: "Saving Lives, Racing Time",
    heroDescription:
      "When every second counts, our Emergency Medical Services and organ transport helicopters deliver life-saving speed. Trust HighKraft Aviation for critical medical missions.",
    overviewTitle: "Emergency Medical & Organ Transport Services",
    overviewText: `HighKraft Aviation provides critical Emergency Medical Services (EMS) helicopter operations, specializing in rapid organ transport. When a life hangs in the balance and ground transportation simply isn't fast enough, our air ambulance services bridge the gap between hope and survival.

Organ transplantation is a race against time. From the moment an organ becomes available, the clock starts ticking. Our dedicated EMS helicopter service ensures organs reach recipient hospitals in the shortest possible time, maintaining the viability window that can mean the difference between life and death.

Our EMS operations are conducted with the utmost precision, coordinating closely with hospitals, transplant teams, and medical professionals. We maintain the highest standards of care, with temperature-controlled environments and specialized equipment for organ preservation during transit.`,
    useCases: [
      {
        title: "Organ Transportation",
        description:
          "Rapid transport of donor organs to recipient hospitals within the critical viability window.",
      },
      {
        title: "Medical Team Transfer",
        description:
          "Swift transportation of surgical teams and medical specialists to donor locations.",
      },
      {
        title: "Blood & Tissue Transport",
        description:
          "Emergency transport of blood supplies, plasma, and tissue samples.",
      },
      {
        title: "Inter-Hospital Transfer",
        description:
          "Critical patient transfers between hospitals for specialized treatment.",
      },
      {
        title: "Disaster Response",
        description:
          "Medical supply delivery and evacuation support during emergencies.",
      },
      {
        title: "Remote Area Medical Support",
        description:
          "Reaching patients in areas inaccessible by ground ambulance.",
      },
    ],
    safetyFeatures: [
      {
        title: "Medical-Certified Aircraft",
        description:
          "Helicopters equipped and certified for medical transport operations.",
      },
      {
        title: "Trained Medical Crews",
        description:
          "Flight crews trained in medical protocols and emergency procedures.",
      },
      {
        title: "Temperature Control Systems",
        description:
          "Specialized equipment maintaining optimal conditions for organ preservation.",
      },
      {
        title: "24/7 Availability",
        description:
          "Round-the-clock readiness for emergency medical missions.",
      },
      {
        title: "Hospital Coordination",
        description:
          "Direct communication links with hospitals and transplant coordinators.",
      },
      {
        title: "Priority Air Corridors",
        description: "Access to priority routing for life-saving missions.",
      },
    ],
    galleryImages: [
      require("../../assets/ems_gal1.jpg"),
      require("../../assets/ems_gal2.jpg"),
      require("../../assets/ems_gal3.jpg"),
    ],
    faqs: [
      {
        question: "How quickly can you respond to an organ transport request?",
        answer:
          "Our EMS team maintains 24/7 readiness. We can be airborne within 30-60 minutes of receiving a confirmed request, depending on location and conditions.",
      },
      {
        question: "What organs can be transported by helicopter?",
        answer:
          "We transport all types of organs including hearts, kidneys, livers, lungs, and pancreas. Each transport is customized based on the specific preservation requirements.",
      },
      {
        question: "Do you coordinate with hospitals directly?",
        answer:
          "Yes, our operations team works directly with transplant coordinators, surgical teams, and hospital staff to ensure seamless coordination throughout the transport.",
      },
      {
        question: "What equipment is available on EMS flights?",
        answer:
          "Our EMS helicopters are equipped with organ preservation containers, temperature monitoring systems, medical supplies, and communication equipment for real-time updates.",
      },
      {
        question: "Can medical personnel accompany the organ?",
        answer:
          "Absolutely. We accommodate transplant surgeons, coordinators, and medical staff who need to accompany organs during transport.",
      },
    ],
    icon: Heart,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default EmsOrganTransport;
